import { render, staticRenderFns } from "./SupportNavbar.vue?vue&type=template&id=3c40b961&scoped=true"
import script from "./SupportNavbar.vue?vue&type=script&lang=js"
export * from "./SupportNavbar.vue?vue&type=script&lang=js"
import style0 from "./SupportNavbar.vue?vue&type=style&index=0&id=3c40b961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c40b961",
  null
  
)

export default component.exports